
    import '/home/ec2-user/Youlify-Design/components/overview/index.en-US.md?watch=parent';
    export const demoIndex = {
  ids: [],
  getter: () => import(/* webpackChunkName: "meta__components__en-US" */'/home/ec2-user/Youlify-Design/components/overview/index.en-US.md?type=demo')
};